<template>
   <div class="pentest-form-view" ref="pentestFormRef">

      <div class="mb-3">
         <h5 style="font-weight: 600;"> Request Details </h5>
      </div>

      <!-- TIMEFRAME -->
      <div class="pentest-field-group">
         <label class="form-label">
            Is there a specific timeframe in which penetration testing needs to be completed?
         </label>
         
         <textarea id="timeframeDetails" class="form-control" :disabled="disableForm()"
            :value="main.hasTimeframe ? main.timeframeDetails : 'None'"></textarea>
      </div>

      <!-- END -- TIMEFRAME -->

      <div class="pentest-field-group">
         <label class="form-label">
            Please provide any additional relevant information.
         </label>
         <textarea class="form-control" id="relevantInformation" v-model.trim="main.relevantInformation"
         :disabled="disableForm()"></textarea>
      </div>

      <!-- <hr> -->

      <!-- <div class="pt-4">
         <h5  style="font-weight: 600;"> Test Types </h5>
      </div> -->

      <div v-if="testTypes.length > 0" id="pentestTypeForms">

         <div v-for="(testType, index) in testTypes" :key="testType.id">
            <hr>
            <div>
               <p class="test-type-title" :id="'formHeader'+index" :class="{'collapsed' : index > 0}"
                  data-bs-toggle="collapse" :data-bs-target="'#form'+index" aria-expanded="true" :aria-controls="'form'+index">
                  {{ testTypeName(testType.name) }} Form
               </p>

               <div :id="'form'+index" class=" collapse" :class="{'show' : index == 0}" 
                  :aria-labelledby="'formHeader'+index" data-bs-parent="#pentestTypeForms">
                  <div v-if="isTestType(testType.name, WEB)">
                     <WebPenTestForm ref="webPentestFormRef" action="view" :items="webPenTestForm" 
                        @downloadFile="downloadFile" @downloadAllFiles="downloadAllFiles"/>
                  </div>
                  <div v-if="isTestType(testType.name, APP)">
                     <AppPenTestForm ref="appPentestFormRef" action="view" :items="appPenTestForm"
                        @downloadFile="downloadFile" @downloadAllFiles="downloadAllFiles"/>
                  </div>
                  <div v-if="isTestType(testType.name, INFRA)">
                     <NetworkInfraPenTestForm ref="networkInfraPentestFormRef" action="view" :items="networkInfraPenTestForm"
                        @downloadFile="downloadFile" @downloadAllFiles="downloadAllFiles"/>
                  </div>
               </div>
               
            </div>
         </div>

      </div>
   </div>

</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import AppPenTestForm from '@/components/Leads/Pentest/AppPenTestForm.vue';
import NetworkInfraPenTestForm from '@/components/Leads/Pentest/NetworkInfraPenTestForm.vue';
import WebPenTestForm from '@/components/Leads/Pentest/WebPenTestForm.vue';

const WEB = "Web"
const INFRA = "Infrastructure"
const APP = "App"

export default({

   components: {
      AppPenTestForm,
      NetworkInfraPenTestForm,
      WebPenTestForm
   },
   
   setup () {
      return { v$: useVuelidate() }
   },

   emits: ['downloadFile', 'downloadAllFiles'],

   props: {
      items: {
         type: Object,
         required: true,
      },
      
   },

   data(){
      return {
         main: {
            hasTimeframe: false,
            timeframeDetails: '',
            relevantInformation: '',
         },
         testTypes: [],
         appPenTestForm: {},
         networkInfraPenTestForm: {},
         webPenTestForm: {},
         isView: false,
         isCreate: false,
      }
      
   }, 

   validations() {
      return {
         main: {
            hasTimeframe: { required },
            timeframeDetails: { requiredIf: requiredIf(this.main.hasTimeframe) }
         }
         
      }
   },

   computed: {
      itemList(){
         return this.items
      },

   },

   watch: {
      itemList(){
         this.init()
         this.resizeTextareas()
      },

   },

   created(){
      this.init()

      //declare constants
      this.APP = APP
      this.INFRA = INFRA
      this.WEB = WEB

   },

   // mounted(){
   //    this.resizeTextareas()
   // },

   methods: {
      init(){
         if (this.action == 'create') {
            this.createForm()
         } else {
            this.viewForm()
            this.resizeTextareas()
            this.populatePenTestForm(this.items)
         }

      },

      createForm(){
         this.isCreate = true
         this.isView = false
      },

      viewForm(){
         this.isCreate = false
         this.isView = true
      },

      //set height of text area to fit content
      resizeTextareas(){
         this.$nextTick(()=>{
            var pentestFormRef = this.$refs.pentestFormRef
            var textareas = pentestFormRef.getElementsByTagName('textarea')

            for(let i = 0; i < textareas.length; i++ ){
               textareas[i].style.height = 0
               textareas[i].style.height = textareas[i].scrollHeight + 2 + 'px';
            }
            
         });
      },

      populatePenTestForm(data){
         // Object.assign(this.webPentestForm, {});
         // Object.assign(this.appPentestForm, {});
         // Object.assign(this.netInfraPentestForm, {});
         //set height of edit note text area to fit content

         data.forEach((p) => {
            if (p.website) {
               this.testTypes.push({
                  name: "Web"
               })
               this.webPenTestForm = p
            } 
            
            
            if (p.app) {
               this.testTypes.push({
                  name: "App"
               })
               this.appPenTestForm = p
            } 
            
            if (p.network_infra) {
               this.testTypes.push({
                  name: "Infrastructure"
               })
               this.networkInfraPenTestForm = p
            }

            this.main.hasTimeframe = p.has_timeframe
            this.main.timeframeDetails = p.timeframe_details
            this.main.relevantInformation = p.relevant_information
         })
      },

      testTypeName(testType){
         if (testType == APP){
            return "Mobile App"
         } else if (testType == INFRA){
            return "Network / Infrastructure"
         } else if (testType == WEB){
            return "Website"
         }

         return ""
      },

      isTestType(testTypeName, type){
         return testTypeName == type

      },

      disableForm(){
         return this.isView
      },

      downloadFile({testType, file}){
         this.$emit('downloadFile', {testType : testType, file : file})
      },

      downloadFileDone(testType, fileId){
         if (testType == 'MobileApp'){
            this.$refs.appPentestFormRef[0].downloadFileDone(fileId)
         } else if (testType == 'NetworkInfrastructure') {
            this.$refs.networkInfraPentestFormRef[0].downloadFileDone(fileId)
         } else if (testType == 'Website') {
            this.$refs.webPentestFormRef[0].downloadFileDone(fileId)
         }
      },

      downloadAllFiles({testType, testTypeId}){
         this.$emit('downloadAllFiles', {testType : testType, testTypeId : testTypeId})
      },

      downloadAllFilesDone(leadId, testType){
         if (testType == 'MobileApp'){
            this.$refs.appPentestFormRef[0].downloadAllFilesDone()
         } else if (testType == 'NetworkInfrastructure') {
            this.$refs.networkInfraPentestFormRef[0].downloadAllFilesDone()
         } else if (testType == 'Website') {
            this.$refs.webPentestFormRef[0].downloadAllFilesDone()
         }
      }

   }
})
</script>
<style scoped>

hr{
   /* width: 600px; */
   border-width: 10px;
   background: #F0F0F0;
}

</style>